<template>
<div v-if="ready" style="padding:20px 20px 20px 20px;">
  <schedaHeader scheda="4" titolo="DECORSO CLINICO" :item="item"></schedaHeader>
  
  <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="360px" class="label-50">



<div class="formRow row">

<!-- {{isAlive}} -->
<div class="col s12" v-if="item.row.deldie==0 && item.row.gruppo==1">       <formLabel variabile="atempm"></formLabel>       <el-form-item prop="atempm">       <formSelectV3 v-model="item.row.atempm" variabile="atempm"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.deldie==0 && item.row.gruppo==1 && item.row.atempm==1">       <formLabel variabile="atemp"></formLabel>       <el-form-item prop="atemp">       <formRangeV3 v-model="item.row.atemp" variabile="atemp"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.deldie==0">       <formLabel variabile="die12"></formLabel>       <el-form-item prop="die12">       <formSelectV3 v-on:change="changeDie12()" v-model="item.row.die12" variabile="die12"></formSelectV3>       </el-form-item>       </div>

</div>
<h2 v-if="isAlive">Sepsi Early e Late</h2>
<div v-if="isAlive" class="formRow row">

<div class="col s12" v-if="isAlive">       <formLabel variabile="ebseps"></formLabel>       <el-form-item prop="ebseps">       <formSelectV3 v-model="item.row.ebseps" variabile="ebseps"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.ebseps==1">       <formLabel variabile="ebsepscd1"></formLabel>       <el-form-item prop="ebsepscd1">       <formSelectV3 v-on:change="ebsepscd()" v-model="item.row.ebsepscd1" variabile="ebsepscd1"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.ebseps==1 && item.row.ebsepscd1>0">       <formLabel variabile="ebsepscd2"></formLabel>       <el-form-item prop="ebsepscd2">       <formSelectV3 v-on:change="ebsepscd()" v-model="item.row.ebsepscd2" variabile="ebsepscd2"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.ebseps==1 && item.row.ebsepscd2>0">       <formLabel variabile="ebsepscd3"></formLabel>       <el-form-item prop="ebsepscd3">       <formSelectV3 v-model="item.row.ebsepscd3" variabile="ebsepscd3"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlivePlus && after3">       <formLabel variabile="lbpath"></formLabel>       <el-form-item prop="lbpath">       <formSelectV3 v-model="item.row.lbpath" variabile="lbpath"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.gruppo==1 &&isAlivePlus && item.row.lbpath==1">       <formLabel variabile="lbpathwo"></formLabel>       <el-form-item prop="lbpathwo">       <formSelectV3 v-model="item.row.lbpathwo" variabile="lbpathwo"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.lbpath==1">       <formLabel variabile="lbpathcd1"></formLabel>       <el-form-item prop="lbpathcd1">       <formSelectV3 v-on:change="lbpathcd()" v-model="item.row.lbpathcd1" variabile="lbpathcd1"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.lbpath==1 && (item.row.lbpathcd1>0 )">       <formLabel variabile="lbpathcd2"></formLabel>       <el-form-item prop="lbpathcd2">       <formSelectV3 v-on:change="lbpathcd()" v-model="item.row.lbpathcd2" variabile="lbpathcd2"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.lbpath==1 && (item.row.lbpathcd2>0 )">       <formLabel variabile="lbpathcd3"></formLabel>       <el-form-item prop="lbpathcd3">       <formSelectV3 v-model="item.row.lbpathcd3" variabile="lbpathcd3"></formSelectV3>       </el-form-item>       </div>


<div class="col s12" v-if="isAlivePlus && after3">       <formLabel variabile="cnegstaph"></formLabel>       <el-form-item prop="cnegstaph">       <formSelectV3 v-model="item.row.cnegstaph" variabile="cnegstaph"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1 && item.row.cnegstaph==1">       <formLabel variabile="cnegwo"></formLabel>       <el-form-item prop="cnegwo">       <formSelectV3 v-model="item.row.cnegwo" variabile="cnegwo"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlivePlus && after3">       <formLabel variabile="fungal"></formLabel>       <el-form-item prop="fungal">       <formSelectV3 v-model="item.row.fungal" variabile="fungal"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1 && item.row.fungal==1">       <formLabel variabile="fungalwo"></formLabel>       <el-form-item prop="fungalwo">       <formSelectV3 v-model="item.row.fungalwo" variabile="fungalwo"></formSelectV3>       </el-form-item>       </div>

  </div>
  <!-- Fine Sepsi Early e Late -->
  <h2>Problemi Respiratori</h2>
  <div class="formRow row">



<div class="col s12" v-if="isAlive">       <formLabel variabile="patoresp"></formLabel>       <el-form-item prop="patoresp">       <formSelectV3 v-on:change="changePatoresp()" v-model="item.row.patoresp" variabile="patoresp"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="oxy"></formLabel>       <el-form-item prop="oxy">       <formSelectV3 v-model="item.row.oxy" variabile="oxy"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="vent"></formLabel>       <el-form-item prop="vent">       <formSelectV3 v-model="item.row.vent" variabile="vent"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="hfv"></formLabel>       <el-form-item prop="hfv">       <formSelectV3 v-model="item.row.hfv" variabile="hfv"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="hfnc"></formLabel>       <el-form-item prop="hfnc">       <formSelectV3 v-model="item.row.hfnc" variabile="hfnc"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.patoresp==1 && item.row.hfnc==1">       <formLabel variabile="ncf_gt_2l"></formLabel>       <el-form-item prop="ncf_gt_2l">       <formSelectV3 v-model="item.row.ncf_gt_2l" variabile="ncf_gt_2l"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="nimv"></formLabel>       <el-form-item prop="nimv">       <formSelectV3 v-model="item.row.nimv" variabile="nimv"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="cpap"></formLabel>       <el-form-item prop="cpap">       <formSelectV3 v-model="item.row.cpap" variabile="cpap"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && isCpapes">       <formLabel variabile="cpapes"></formLabel>       <el-form-item prop="cpapes">       <formSelectV3 v-model="item.row.cpapes" variabile="cpapes"></formSelectV3>       </el-form-item>       </div>


<div class="col s12" v-if="item.row.patoresp==1 && item.row.drsurf!=1">       <formLabel variabile="surfx"></formLabel>       <el-form-item prop="surfx">       <formSelectV3 v-model="item.row.surfx" variabile="surfx"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.drsurf==1 || item.row.surfx==1">       <formLabel variabile="surf1dhr"></formLabel>       <el-form-item prop="surf1dhr">       <formRangeV3 v-model="item.row.surf1dhr" variabile="surf1dhr"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.drsurf==1 || item.row.surfx==1">       <formLabel variabile="surf1dmin"></formLabel>       <el-form-item prop="surf1dmin">       <formRangeV3 v-model="item.row.surf1dmin" variabile="surf1dmin"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.drsurf==1 || item.row.surfx==1">       <formLabel variabile="fio2surf"></formLabel>       <el-form-item prop="fio2surf">       <formRangeV3 v-model="item.row.fio2surf" variabile="fio2surf"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.drsurf==1 || item.row.surfx==1">       <formLabel variabile="nsurf"></formLabel>       <el-form-item prop="nsurf">       <formSelectV3 v-model="item.row.nsurf" variabile="nsurf"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.deldie!=1 && (item.row.drsurf==1 || item.row.surfx==1)">       <formLabel variabile="insure"></formLabel>       <el-form-item prop="insure">       <formSelectV3 v-model="item.row.insure" variabile="insure"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.deldie!=1 && (item.row.drsurf==1 || item.row.surfx==1)">       <formLabel variabile="lisa"></formLabel>       <el-form-item prop="lisa">       <formSelectV3 v-model="item.row.lisa" variabile="lisa"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.deldie!=1 && (item.row.drsurf==1 || item.row.surfx==1) && item.row.lisa==1">       <formLabel variabile="prelisa"></formLabel>       <el-form-item prop="prelisa">       <formSelectV3 v-model="item.row.prelisa" variabile="prelisa"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.deldie!=1 && (item.row.drsurf==1 || item.row.surfx==1) && item.row.lisa==1 && item.row.prelisa==1">       <formLabel variabile="tipoprelisa"></formLabel>       <el-form-item prop="tipoprelisa">       <formSelectmultipleV3 v-model="item.row.tipoprelisa" variabile="tipoprelisa"></formSelectmultipleV3>       </el-form-item>       </div>


<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="ino"></formLabel>       <el-form-item prop="ino">       <formSelectV3 v-model="item.row.ino" variabile="ino"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.ino==1">       <formLabel variabile="inowg"></formLabel>       <el-form-item prop="inowg">       <formSelectV3 v-model="item.row.inowg" variabile="inowg"></formSelectV3>       </el-form-item>       </div>

      <div class="col s12" v-if="isAlive && item.row.patoresp==1">
      <label  class="el-form-item__label ">
      <div>Data di compimento del 28esimo giorno</div>
      </label>
      <el-form-item  >
      <div class="yo-align-left" style="padding-left:12px;">{{$centro.giorno28(item.row.datanascita) | data('DD MMMM YYYY')}}</div>
      </el-form-item>
      </div>

<div class="col s12" v-if="isAliveLocate && item.row.patoresp==1 && after28">       <formLabel variabile="newox28"></formLabel>       <el-form-item prop="newox28">       <formSelectV3 v-model="item.row.newox28" variabile="newox28"></formSelectV3>       </el-form-item>       </div>

      <div class="col s12" v-if="isAlive && item.row.patoresp==1">
      <label  class="el-form-item__label ">
      <div>Data di compimento della 36 settimana</div>
      </label>
      <el-form-item  >
      <div class="yo-align-left" style="padding-left:12px;">{{$centro.settimana36(item.row.datanascita,item.row.gaweeks,item.row.gadays)  | data('DD MMMM YYYY')}} </div>
      </el-form-item>
      </div>
      
<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1">       <formLabel variabile="ox36"></formLabel>       <el-form-item prop="ox36">       <formSelectV3 v-model="item.row.ox36" variabile="ox36"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1 && item.row.ox36==1">       <formLabel variabile="fio236"></formLabel>       <el-form-item prop="fio236">       <formRangeV3 v-model="item.row.fio236" variabile="fio236"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1">       <formLabel variabile="vent36"></formLabel>       <el-form-item prop="vent36">       <formSelectV3 v-model="item.row.vent36" variabile="vent36"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1">       <formLabel variabile="hfv36"></formLabel>       <el-form-item prop="hfv36">       <formSelectV3 v-model="item.row.hfv36" variabile="hfv36"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1">       <formLabel variabile="hfnc36"></formLabel>       <el-form-item prop="hfnc36">       <formSelectV3 v-model="item.row.hfnc36" variabile="hfnc36"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1 && item.row.hfnc36==1">       <formLabel variabile="ncf36_gt_2l"></formLabel>       <el-form-item prop="ncf36_gt_2l">       <formSelectV3 v-model="item.row.ncf36_gt_2l" variabile="ncf36_gt_2l"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1">       <formLabel variabile="nimv36"></formLabel>       <el-form-item prop="nimv36">       <formSelectV3 v-model="item.row.nimv36" variabile="nimv36"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && after36 && item.row.patoresp==1 && item.row.gruppo==1">       <formLabel variabile="cpap36"></formLabel>       <el-form-item prop="cpap36">       <formSelectV3 v-model="item.row.cpap36" variabile="cpap36"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAliveLocate && item.row.patoresp==1">       <formLabel variabile="sterbpd"></formLabel>       <el-form-item prop="sterbpd">       <formSelectV3 v-model="item.row.sterbpd" variabile="sterbpd"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.patoresp==1 && item.row.gruppo==1 && item.row.sterbpd==1">       <formLabel variabile="sterbpdwg"></formLabel>       <el-form-item prop="sterbpdwg">       <formSelectV3 v-model="item.row.sterbpdwg" variabile="sterbpdwg"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAliveLocate && after28 && item.row.patoresp==1 ">       <formLabel variabile="bpd"></formLabel>       <el-form-item prop="bpd">       <formSelectV3 v-model="item.row.bpd" variabile="bpd"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && after28 && item.row.bpd==1">       <formLabel variabile="bpdgrado"></formLabel>       <el-form-item prop="bpdgrado">       <formSelectV3 v-model="item.row.bpdgrado" variabile="bpdgrado"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="apnea"></formLabel>       <el-form-item prop="apnea">       <formSelectV3 v-model="item.row.apnea" variabile="apnea"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.patoresp==1 && item.row.surfx!=1">       <formLabel variabile="ttn"></formLabel>       <el-form-item prop="ttn">       <formSelectV3 v-model="item.row.ttn" variabile="ttn"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="rds"></formLabel>       <el-form-item prop="rds">       <formSelectV3 v-model="item.row.rds" variabile="rds"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.patoresp==1">       <formLabel variabile="pntx"></formLabel>       <el-form-item prop="pntx">       <formSelectV3 v-model="item.row.pntx" variabile="pntx"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.pntx==1">       <formLabel variabile="pntxwo"></formLabel>       <el-form-item prop="pntxwo">       <formSelectV3 v-model="item.row.pntxwo" variabile="pntxwo"></formSelectV3>       </el-form-item>       </div>


  </div>
  <!-- Problemi Respiratori -->
  <h2 >Problemi Cerebrali</h2>
  <div class="formRow row">


<div class="col s12" v-if="isAlive">       <formLabel variabile="usound1"></formLabel>       <el-form-item prop="usound1">       <formSelectV3 v-on:change="changeUsound1()" v-model="item.row.usound1" variabile="usound1"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.usound1==1">       <formLabel variabile="ugrade1"></formLabel>       <el-form-item prop="ugrade1">       <formSelectV3 v-model="item.row.ugrade1" variabile="ugrade1"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.ugrade1>=1">       <formLabel variabile="pihwfo"></formLabel>       <el-form-item prop="pihwfo">       <formSelectV3 v-model="item.row.pihwfo" variabile="pihwfo"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.usound1==1">       <formLabel variabile="pvl"></formLabel>       <el-form-item prop="pvl">       <formSelectV3 v-model="item.row.pvl" variabile="pvl"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.usound1==1 && item.row.pvl==1">       <formLabel variabile="pvlgrado"></formLabel>       <el-form-item prop="pvlgrado">       <formSelectV3 v-model="item.row.pvlgrado" variabile="pvlgrado"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="item.row.gruppo==2">       <formLabel variabile="eii"></formLabel>       <el-form-item prop="eii">       <formSelectV3 v-model="item.row.eii" variabile="eii"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.gruppo==2 && item.row.eii==1">       <formLabel variabile="ipotermia"></formLabel>       <el-form-item prop="ipotermia">       <formSelectV3 v-model="item.row.ipotermia" variabile="ipotermia"></formSelectV3>       </el-form-item>       </div>

  </div>
  <!-- Fine Problemi Cerebrali -->
  <h2>Altre patologie</h2>
  <div class="formRow row">
    
<div class="col s12">       <formLabel variabile="cmal"></formLabel>       <el-form-item prop="cmal">       <formSelectV3 v-model="item.row.cmal" variabile="cmal"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.gruppo==1 && item.row.cmal==1">       <formLabel variabile="bdcd1"></formLabel>
       <el-form-item prop="bdcd1gruppo">       <formSelectV3 v-on:change="bdcd()" v-model="item.row.bdcd1gruppo" variabile="bdcd1gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
       <el-form-item prop="bdcd1" v-if="item.row.cmal==1 && item.row.bdcd1gruppo>0">       <formSelectV3 v-model="item.row.bdcd1" variabile="bdcd1" :gruppo="item.row.bdcd1gruppo"></formSelectV3>       </el-form-item> 
</div>
<div class="col s12" v-if="item.row.gruppo==1 && item.row.cmal==1 && item.row.bdcd1gruppo>0">       <formLabel variabile="bdcd2"></formLabel>
       <el-form-item prop="bdcd2gruppo">       <formSelectV3 v-on:change="bdcd()" v-model="item.row.bdcd2gruppo" variabile="bdcd2gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
       <el-form-item prop="bdcd2" v-if="item.row.cmal==1 && item.row.bdcd2gruppo>0">       <formSelectV3 v-model="item.row.bdcd2" variabile="bdcd2" :gruppo="item.row.bdcd2gruppo"></formSelectV3>       </el-form-item> 
</div>
<div class="col s12" v-if="item.row.gruppo==1 && item.row.cmal==1 && item.row.bdcd2gruppo>0">       <formLabel variabile="bdcd3"></formLabel>
       <el-form-item prop="bdcd3gruppo">       <formSelectV3 v-on:change="bdcd()" v-model="item.row.bdcd3gruppo" variabile="bdcd3gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
       <el-form-item prop="bdcd3" v-if="item.row.cmal==1 && item.row.bdcd3gruppo>0">       <formSelectV3 v-model="item.row.bdcd3" variabile="bdcd3" :gruppo="item.row.bdcd3gruppo"></formSelectV3>       </el-form-item> 
</div>
<div class="col s12" v-if="item.row.gruppo==1 && item.row.cmal==1 && item.row.bdcd3gruppo>0">       <formLabel variabile="bdcd4"></formLabel>
       <el-form-item prop="bdcd4gruppo">       <formSelectV3 v-on:change="bdcd()" v-model="item.row.bdcd4gruppo" variabile="bdcd4gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
       <el-form-item prop="bdcd4" v-if="item.row.cmal==1 && item.row.bdcd4gruppo>0">       <formSelectV3 v-model="item.row.bdcd4" variabile="bdcd4" :gruppo="item.row.bdcd4gruppo"></formSelectV3>       </el-form-item> 
</div>
<div class="col s12" v-if="item.row.gruppo==1 && item.row.cmal==1 && item.row.bdcd4gruppo>0">       <formLabel variabile="bdcd5"></formLabel>
       <el-form-item prop="bdcd5gruppo">       <formSelectV3 v-on:change="bdcd()" v-model="item.row.bdcd5gruppo" variabile="bdcd5gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
       <el-form-item prop="bdcd5" v-if="item.row.cmal==1 && item.row.bdcd5gruppo>0">       <formSelectV3 v-model="item.row.bdcd5" variabile="bdcd5" :gruppo="item.row.bdcd5gruppo"></formSelectV3>       </el-form-item> 
</div>



<!-- Tolto in attesa di verifica da parte del VON se possiabile inviare la variabile vuota
<div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="bdefect"></formLabel>       <el-form-item prop="bdefect">       <formInputV3 v-model="item.row.bdefect" variabile="bdefect"></formInputV3>       </el-form-item>       </div>
-->


<div class="col s12" v-if="isAliveLocate && item.row.gruppo==1">       <formLabel variabile="eyex"></formLabel>       <el-form-item prop="eyex">       <formSelectV3 v-model="item.row.eyex" variabile="eyex"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.gruppo==1 && item.row.eyex==1">       <formLabel variabile="istage"></formLabel>       <el-form-item prop="istage">       <formSelectV3 v-model="item.row.istage" variabile="istage"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.gruppo==1 && item.row.eyex==1 && item.row.istage!=0">       <formLabel variabile="ropantivegf"></formLabel>       <el-form-item prop="ropantivegf">       <formSelectV3 v-model="item.row.ropantivegf" variabile="ropantivegf"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAliveLocate && item.row.gruppo==1 && item.row.eyex==1 && item.row.istage!=0">       <formLabel variabile="ropsurg"></formLabel>       <el-form-item prop="ropsurg">       <formSelectV3 v-model="item.row.ropsurg" variabile="ropsurg"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.gruppo==1 && item.row.eyex==1  && item.row.istage!=0 && item.row.ropsurg==1">       <formLabel variabile="ropsurgwd"></formLabel>       <el-form-item prop="ropsurgwd">       <formSelectV3 v-model="item.row.ropsurgwd" variabile="ropsurgwd"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1">       <formLabel variabile="pda"></formLabel>       <el-form-item prop="pda">       <formSelectV3 v-model="item.row.pda" variabile="pda"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.pda==1">       <formLabel variabile="ibuprofen"></formLabel>       <el-form-item prop="ibuprofen">       <formSelectV3 v-model="item.row.ibuprofen" variabile="ibuprofen"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.pda==1">       <formLabel variabile="acetamin"></formLabel>       <el-form-item prop="acetamin">       <formSelectV3 v-model="item.row.acetamin" variabile="acetamin"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1">       <formLabel variabile="indometh"></formLabel>       <el-form-item prop="indometh">       <formSelectV3 v-model="item.row.indometh" variabile="indometh"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.pda==1">       <formLabel variabile="pdasurg"></formLabel>       <el-form-item prop="pdasurg">       <formSelectV3 v-model="item.row.pdasurg" variabile="pdasurg"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive">       <formLabel variabile="nec"></formLabel>       <el-form-item prop="nec">       <formSelectV3 v-model="item.row.nec" variabile="nec"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1 && item.row.nec==1">       <formLabel variabile="necwo"></formLabel>       <el-form-item prop="necwo">       <formSelectV3 v-model="item.row.necwo" variabile="necwo"></formSelectV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlive">       <formLabel variabile="giperf"></formLabel>       <el-form-item prop="giperf">       <formSelectV3 v-model="item.row.giperf" variabile="giperf"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.giperf==1">       <formLabel variabile="giperfwo"></formLabel>       <el-form-item prop="giperfwo">       <formSelectV3 v-model="item.row.giperfwo" variabile="giperfwo"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && (item.row.giperf==1 || item.row.nec==1)">       <formLabel variabile="necsurg"></formLabel>       <el-form-item prop="necsurg">       <formSelectV3 v-model="item.row.necsurg" variabile="necsurg"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1">       <formLabel variabile="osurg"></formLabel>       <el-form-item prop="osurg">       <formSelectV3 v-model="item.row.osurg" variabile="osurg"></formSelectV3>       </el-form-item>       </div>

<!--
<div class="col s12">       <formLabel variabile="srgcd1"></formLabel>       <el-form-item prop="srgcd1">       <formInputV3 v-model="item.row.srgcd1" variabile="srgcd1"></formInputV3>       </el-form-item>       </div>
-->

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1)">       <formLabel variabile="srgcd1"></formLabel>
      <el-form-item prop="srgcd1gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd1gruppo" variabile="srgcd1gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd1" v-if="item.row.srgcd1gruppo>0">       <formSelectV3 v-model="item.row.srgcd1" variabile="srgcd1" :gruppo="item.row.srgcd1gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1)">
      <formLabel variabile="srgloc1"></formLabel>       <el-form-item prop="srgloc1">       <formSelectV3 v-model="item.row.srgloc1" variabile="srgloc1"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi1"></formLabel>       <el-form-item prop="srgssi1">       <formSelectV3 v-model="item.row.srgssi1" variabile="srgssi1"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd1gruppo>-127">       <formLabel variabile="srgcd2"></formLabel>
      <el-form-item prop="srgcd2gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd2gruppo" variabile="srgcd2gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd2" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd1gruppo>0">       <formSelectV3 v-model="item.row.srgcd2" variabile="srgcd2" :gruppo="item.row.srgcd2gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd1gruppo>-127">
      <formLabel variabile="srgloc2"></formLabel>       <el-form-item prop="srgloc2">       <formSelectV3 v-model="item.row.srgloc2" variabile="srgloc2"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi2"></formLabel>       <el-form-item prop="srgssi2">       <formSelectV3 v-model="item.row.srgssi2" variabile="srgssi2"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd2gruppo>-127">       <formLabel variabile="srgcd3"></formLabel>
      <el-form-item prop="srgcd3gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd3gruppo" variabile="srgcd3gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd3" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd2gruppo>0">       <formSelectV3 v-model="item.row.srgcd3" variabile="srgcd3" :gruppo="item.row.srgcd3gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd2gruppo>-127">
      <formLabel variabile="srgloc3"></formLabel>       <el-form-item prop="srgloc3">       <formSelectV3 v-model="item.row.srgloc3" variabile="srgloc3"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi3"></formLabel>       <el-form-item prop="srgssi3">       <formSelectV3 v-model="item.row.srgssi3" variabile="srgssi3"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd3gruppo>-127">       <formLabel variabile="srgcd4"></formLabel>
      <el-form-item prop="srgcd4gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd4gruppo" variabile="srgcd4gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd4" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd3gruppo>0">       <formSelectV3 v-model="item.row.srgcd4" variabile="srgcd4" :gruppo="item.row.srgcd4gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd3gruppo>-127">
      <formLabel variabile="srgloc4"></formLabel>       <el-form-item prop="srgloc4">       <formSelectV3 v-model="item.row.srgloc4" variabile="srgloc4"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi4"></formLabel>       <el-form-item prop="srgssi4">       <formSelectV3 v-model="item.row.srgssi4" variabile="srgssi4"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd4gruppo>-127">       <formLabel variabile="srgcd5"></formLabel>
      <el-form-item prop="srgcd5gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd5gruppo" variabile="srgcd5gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd5" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd4gruppo>0">       <formSelectV3 v-model="item.row.srgcd5" variabile="srgcd5" :gruppo="item.row.srgcd5gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd4gruppo>-127">
      <formLabel variabile="srgloc5"></formLabel>       <el-form-item prop="srgloc5">       <formSelectV3 v-model="item.row.srgloc5" variabile="srgloc5"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi5"></formLabel>       <el-form-item prop="srgssi5">       <formSelectV3 v-model="item.row.srgssi5" variabile="srgssi5"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd5gruppo>-127">       <formLabel variabile="srgcd6"></formLabel>
      <el-form-item prop="srgcd6gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd6gruppo" variabile="srgcd6gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd6" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd5gruppo>0">       <formSelectV3 v-model="item.row.srgcd6" variabile="srgcd6" :gruppo="item.row.srgcd6gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd5gruppo>-127">
      <formLabel variabile="srgloc6"></formLabel>       <el-form-item prop="srgloc6">       <formSelectV3 v-model="item.row.srgloc6" variabile="srgloc6"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi6"></formLabel>       <el-form-item prop="srgssi6">       <formSelectV3 v-model="item.row.srgssi6" variabile="srgssi6"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd6gruppo>-127">       <formLabel variabile="srgcd7"></formLabel>
      <el-form-item prop="srgcd7gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd7gruppo" variabile="srgcd7gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd7" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd6gruppo>0">       <formSelectV3 v-model="item.row.srgcd7" variabile="srgcd7" :gruppo="item.row.srgcd7gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd6gruppo>-127">
      <formLabel variabile="srgloc7"></formLabel>       <el-form-item prop="srgloc7">       <formSelectV3 v-model="item.row.srgloc7" variabile="srgloc7"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi7"></formLabel>       <el-form-item prop="srgssi7">       <formSelectV3 v-model="item.row.srgssi7" variabile="srgssi7"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd7gruppo>-127">       <formLabel variabile="srgcd8"></formLabel>
      <el-form-item prop="srgcd8gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd8gruppo" variabile="srgcd8gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd8" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd7gruppo>0">       <formSelectV3 v-model="item.row.srgcd8" variabile="srgcd8" :gruppo="item.row.srgcd8gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd7gruppo>-127">
      <formLabel variabile="srgloc8"></formLabel>       <el-form-item prop="srgloc8">       <formSelectV3 v-model="item.row.srgloc8" variabile="srgloc8"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi8"></formLabel>       <el-form-item prop="srgssi8">       <formSelectV3 v-model="item.row.srgssi8" variabile="srgssi8"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd8gruppo>-127">       <formLabel variabile="srgcd9"></formLabel>
      <el-form-item prop="srgcd9gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd9gruppo" variabile="srgcd9gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd9" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd8gruppo>0">       <formSelectV3 v-model="item.row.srgcd9" variabile="srgcd9" :gruppo="item.row.srgcd9gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd8gruppo>-127">
      <formLabel variabile="srgloc9"></formLabel>       <el-form-item prop="srgloc9">       <formSelectV3 v-model="item.row.srgloc9" variabile="srgloc9"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi9"></formLabel>       <el-form-item prop="srgssi9">       <formSelectV3 v-model="item.row.srgssi9" variabile="srgssi9"></formSelectV3>       </el-form-item>
      </span>
</div>

<div class="col s12" v-if="isAlive && item.row.gruppo==1 && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd9gruppo>-127">       <formLabel variabile="srgcd10"></formLabel>
      <el-form-item prop="srgcd10gruppo">       <formSelectV3 v-on:change="srgcd()" v-model="item.row.srgcd10gruppo" variabile="srgcd10gruppo" gruppo="0"></formSelectV3>       </el-form-item>      
      <el-form-item prop="srgcd10" v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd9gruppo>0">       <formSelectV3 v-model="item.row.srgcd10" variabile="srgcd10" :gruppo="item.row.srgcd10gruppo"></formSelectV3>       </el-form-item> 
      <span v-if="isAlive && (item.row.osurg==1 || item.row.pdasurg==1 || item.row.necsurg==1) && item.row.srgcd9gruppo>-127">
      <formLabel variabile="srgloc10"></formLabel>       <el-form-item prop="srgloc10">       <formSelectV3 v-model="item.row.srgloc10" variabile="srgloc10"></formSelectV3>       </el-form-item>
      <formLabel variabile="srgssi10"></formLabel>       <el-form-item prop="srgssi10">       <formSelectV3 v-model="item.row.srgssi10" variabile="srgssi10"></formSelectV3>       </el-form-item>
      </span>
</div>



<!-- Nascosta in attesa di news dal VON
  <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="osrgdesc"></formLabel>       <el-form-item prop="osrgdesc">       <formInputV3 v-model="item.row.osrgdesc" variabile="osrgdesc"></formInputV3>       </el-form-item>       </div>
-->



  </div>
  <!-- Fine Altre patologie -->
  <h2 v-if="isAlive">Altro......</h2>
  <div v-if="isAlive" class="formRow row">


<div class="col s12" v-if="this.$moment(item.row.dataesito)>=this.$moment(item.row.dataricovero) ">
    <formLabel variabile="los1"></formLabel>
    <el-form-item prop="los1">
    <div class="yo-align-left" style="padding-left:12px;">{{this.$moment(item.row.dataesito).diff( this.$moment(item.row.dataricovero) ,'days')+1}}</div>
    </el-form-item>
</div>

<!-- Campo valido solo per EG ≥ 35 e peso ≥ 1800g -->
<div class="col s12" v-if="isAlive">       <formLabel variabile="npgg"></formLabel>       <el-form-item prop="npgg">       <formRangeV3 v-model="item.row.npgg" variabile="npgg"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive">       <formLabel variabile="negg"></formLabel>       <el-form-item prop="negg">       <formRangeV3 v-model="item.row.negg" variabile="negg" v-on:change="changeNegg"></formRangeV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlivePlus && item.row.negg>0">       <formLabel variabile="inizionegg"></formLabel>       <el-form-item prop="inizionegg">       <formRangeV3 v-model="item.row.inizionegg" variabile="inizionegg"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.negg>0">       <formLabel variabile="neconlm"></formLabel>       <el-form-item prop="neconlm">       <formRangeV3 v-model="item.row.neconlm" variabile="neconlm"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.negg>0">       <formLabel variabile="neconla"></formLabel>       <el-form-item prop="neconla">       <formRangeV3 v-model="item.row.neconla" variabile="neconla"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.negg>0">       <formLabel variabile="neconlm_la"></formLabel>       <el-form-item prop="neconlm_la">       <formRangeV3 v-model="item.row.neconlm_la" variabile="neconlm_la"></formRangeV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1 && (item.row.neconlm>0 || item.row.neconlm_la>0)">       <formLabel variabile="lmbanca"></formLabel>       <el-form-item prop="lmbanca">       <formSelectV3 v-model="item.row.lmbanca" variabile="lmbanca"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1 && (item.row.neconlm>0 || item.row.neconlm_la>0)">       <formLabel variabile="lmfortificato"></formLabel>       <el-form-item prop="lmfortificato">       <formSelectV3 v-model="item.row.lmfortificato" variabile="lmfortificato"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive">       <formLabel variabile="digiuno"></formLabel>       <el-form-item prop="digiuno">       <formRangeV3 v-model="item.row.digiuno" variabile="digiuno"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus">       <formLabel variabile="proteine"></formLabel>       <el-form-item prop="proteine">       <formSelectV3 v-model="item.row.proteine" variabile="proteine"></formSelectV3>       </el-form-item>       </div>


<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1">       <formLabel variabile="fef"></formLabel>       <el-form-item prop="fef">       <formSelectV3 v-model="item.row.fef" variabile="fef" v-on:change="changeFef"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1 && item.row.fef==1">       <formLabel variabile="fefgg"></formLabel>       <el-form-item prop="fefgg">       <formRangeV3 v-model="item.row.fefgg" variabile="fefgg"></formRangeV3>       </el-form-item>       </div>

<div class="col s12" v-if="isAlivePlus && item.row.gruppo==1">       <formLabel variabile="colestasi"></formLabel>       <el-form-item prop="colestasi">       <formSelectV3 v-model="item.row.colestasi" variabile="colestasi"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.gruppo==1">       <formLabel variabile="epo"></formLabel>       <el-form-item prop="epo">       <formSelectV3 v-model="item.row.epo" variabile="epo"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive">       <formLabel variabile="ec"></formLabel>       <el-form-item prop="ec">       <formSelectV3 v-model="item.row.ec" variabile="ec"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate">       <formLabel variabile="probiotics"></formLabel>       <el-form-item prop="probiotics">       <formSelectV3 v-model="item.row.probiotics" variabile="probiotics"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive">       <formLabel variabile="caffeine"></formLabel>       <el-form-item prop="caffeine">       <formSelectV3 v-model="item.row.caffeine" v-on:change="changeCaffeine" variabile="caffeine"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.caffeine==1">       <formLabel variabile="tcaffeine"></formLabel>       <el-form-item prop="tcaffeine">       <formSelectV3 v-model="item.row.tcaffeine" variabile="tcaffeine"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAliveLocate && item.row.caffeine==1">       <formLabel variabile="gginicaffeine"></formLabel>       <el-form-item prop="gginicaffeine">       <formRangeV3 v-model="item.row.gginicaffeine" variabile="gginicaffeine"></formRangeV3>       </el-form-item>       </div>
<div class="col s12" v-if="isAlive && item.row.gruppo==1">       <formLabel variabile="vitamina"></formLabel>       <el-form-item prop="vitamina">       <formSelectV3 v-model="item.row.vitamina" variabile="vitamina"></formSelectV3>       </el-form-item>       </div>


   </div>
   <!-- Fine Altro...... -->

    <div v-if="item.row.chiusoil=='0000-00-00 00:00:00'" class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m3">
        <el-button style="width:100%;" @click="onCancel">Indietro</el-button>
        </div> 
      <div class="col s12 m4 offset-m5">
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva e procedi</el-button>
      </div>
    </div>

    <div v-else class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m4 offset-m8" >
        <el-button style="width:100%;"  @click="$router.push('/home')">Annulla</el-button>
      </div>
    </div>


  



  </el-form>



</div>
</template>

<script>
/*
QUERY
SELECT id,LOWER(nome),posizione,tipo,risposte,answer,nc,na,domanda,help FROM `variabile` WHERE scheda=4 ORDER BY posizione
*/
import schedaHeader from './Scheda-header.vue'
import formLabel from './Form-label.vue'
import formSelectV3 from './Form-select-v3.vue'
import formRangeV3 from './Form-range-v3.vue'
import formInputV3 from './Form-input-v3.vue'
import formSelectmultipleV3 from './Form-selectmultiple-v3.vue'
import formSelectBdcd from './Form-select-bdcd.vue'



import dbItem from '../teras/dbItem'

export default {
  name: 'scheda-datigenerali',
  components: {
     schedaHeader
     ,formLabel
     ,formSelectV3
     ,formSelectmultipleV3
     ,formRangeV3
     ,formInputV3
     ,formSelectBdcd
  },
  data() {
    return {
      loading:{}
      ,ready: false
      ,item:{}
      ,rowBanca:[]
    }
  },
  created: async function () {
    console.log("Arrivo  scheda-datigenerali.vue con id "+this.$route.params.id)
    this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    this.item = new dbItem({table:'paziente'})
    await this.item.load(this.$route.params.id)

    if(this.item.row.centro==0)
      this.item.row.centro = this.$centro.referente.row.centro

    if(this.item.rowIsNew){
      this.item.row.creatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
      this.item.row.creatoda=this.$teras.utente.id//this.$centro.referente.row.id

      this.item.row.byear = this.$moment().format('YYYY')
    }else{
      //mettere il nome della pagina cme modifica
    }


    if(this.item.row.srgcd1gruppo<0) this.item.row.srgcd1gruppo=-127
    if(this.item.row.srgcd2gruppo<0) this.item.row.srgcd2gruppo=-127
    if(this.item.row.srgcd3gruppo<0) this.item.row.srgcd3gruppo=-127
    if(this.item.row.srgcd4gruppo<0) this.item.row.srgcd4gruppo=-127
    if(this.item.row.srgcd5gruppo<0) this.item.row.srgcd5gruppo=-127
    if(this.item.row.srgcd6gruppo<0) this.item.row.srgcd6gruppo=-127
    if(this.item.row.srgcd7gruppo<0) this.item.row.srgcd7gruppo=-127
    if(this.item.row.srgcd8gruppo<0) this.item.row.srgcd8gruppo=-127
    if(this.item.row.srgcd9gruppo<0) this.item.row.srgcd9gruppo=-127
    if(this.item.row.srgcd10gruppo<0) this.item.row.srgcd10gruppo=-127
    if(this.item.row.srgcd1<0) this.item.row.srgcd1=-127
    if(this.item.row.srgcd2<0) this.item.row.srgcd2=-127
    if(this.item.row.srgcd3<0) this.item.row.srgcd3=-127
    if(this.item.row.srgcd4<0) this.item.row.srgcd4=-127
    if(this.item.row.srgcd5<0) this.item.row.srgcd5=-127
    if(this.item.row.srgcd6<0) this.item.row.srgcd6=-127
    if(this.item.row.srgcd7<0) this.item.row.srgcd7=-127
    if(this.item.row.srgcd8<0) this.item.row.srgcd8=-127
    if(this.item.row.srgcd9<0) this.item.row.srgcd9=-127
    if(this.item.row.srgcd10<0) this.item.row.srgcd10=-127


    for (let property in this.item.row){
      if(this.item.row[property]==-7)
        this.item.row[property]=-127
    }
      
    
    setTimeout(() =>{ 
      this.loading.close()
      this.ready = true 
    }, 1000)
    
  },
  mounted(){
    
  },
  methods: {
    changeCaffeine: function(){
      if(this.item.row.caffeine==1){
          if(this.item.row.gginicaffeine<0 && this.item.row.gginicaffeine!=-9)
            this.item.row.gginicaffeine=-127
      }
    }, 
    changeNegg: function(){
      if(this.item.row.negg>0){
          if(this.item.row.inizionegg<0 && this.item.row.inizionegg!=-9)
            this.item.row.inizionegg=-127

          if(this.item.row.neconla<0 && this.item.row.neconla!=-9)
            this.item.row.neconla=-127

          if(this.item.row.neconlm<0 && this.item.row.neconlm!=-9)
            this.item.row.neconlm=-127

          if(this.item.row.neconlm_la<0 && this.item.row.neconlm_la!=-9)
            this.item.row.neconlm_la=-127

            
      }
    }, 
    changeFef: function(){
      if(this.item.row.fef!=1){
          this.item.row.fefgg=-127
      }
    },
    changeUsound1: function (){
      if(this.item.row.usound1==1){
        if(this.item.row.ugrade1<0) this.item.row.ugrade1 = -127;
        if(this.item.row.pihwfo<0) this.item.row.pihwfo = -127;
        if(this.item.rowpvl<0) this.item.row.pvl = -127;
        if(this.item.row.pvlgrado<0) this.item.row.pvlgrado = -127;
      }
    },
    changeDie12: function(){
      if(this.item.row.die12==0){
        console.log("changeDie12")
        // tolto perchè andava a cancellare la data esito inserita
          //this.item.row.dataesito=''
      }
    },  
    changePatoresp: function(){
      if(this.item.row.patoresp==0 && this.item.row.drsurf!=1){
          this.item.row.surfx=0
      }
      if(this.item.row.patoresp==1){
          if(this.item.row.oxy<0) this.item.row.oxy = -127;
          if(this.item.row.vent<0) this.item.row.vent = -127;
          if(this.item.row.hfv<0) this.item.row.hfv = -127;
          if(this.item.row.hfnc<0) this.item.row.hfnc = -127;
          if(this.item.row.ncf_gt_2l<0) this.item.row.ncf_gt_2l = -127;
          if(this.item.row.nimv<0) this.item.row.nimv = -127;
          if(this.item.row.cpap<0) this.item.row.cpap = -127;
          if(this.item.row.surfx<0) this.item.row.surfx = -127;
          if(this.item.row.ino<0) this.item.row.ino = -127;
          if(this.item.row.newox28<0) this.item.row.newox28 = -127;
          if(this.item.row.ox36<0) this.item.row.ox36 = -127;          
          if(this.item.row.vent36<0) this.item.row.vent36 = -127;
          if(this.item.row.hfv36<0) this.item.row.hfv36 = -127;
          if(this.item.row.hfnc36<0) this.item.row.hfnc36 = -127;
          if(this.item.row.ncf36_gt_2l<0) this.item.row.ncf36_gt_2l = -127;
          if(this.item.row.nimv36<0) this.item.row.nimv36 = -127;
          if(this.item.row.cpap36<0) this.item.row.cpap36 = -127;
          if(this.item.row.sterbpd<0) this.item.row.sterbpd = -127;
          if(this.item.row.bpd<0) this.item.row.bpd = -127;
          if(this.item.row.apnea<0) this.item.row.apnea = -127;
          if(this.item.row.ttn<0) this.item.row.ttn = -127;
          if(this.item.row.rds<0) this.item.row.rds = -127;
          if(this.item.row.pntx<0) this.item.row.pntx = -127;
          if(this.item.row.fio236<0) this.item.row.fio236 = -127;
          if(this.item.row.oxfinal<0) this.item.row.oxfinal = -127;
          if(this.item.row.ventfinal<0) this.item.row.ventfinal = -127;
          if(this.item.row.hfvfinal<0) this.item.row.hfvfinal = -127;
          if(this.item.row.hfncfinal<0) this.item.row.hfncfinal = -127;
          if(this.item.row.ncffinal_gt_2l<0) this.item.row.ncffinal_gt_2l = -127;
          if(this.item.row.nimvfinal<0) this.item.row.nimvfinal = -127;
          this.item.row.cpapfinal = 0;
      }
    },
    srgcd: function(){
      if(this.item.row.srgcd1gruppo<0){
        this.item.row.srgcd2gruppo=-127
        this.item.row.srgcd3gruppo=-127
        this.item.row.srgcd4gruppo=-127
        this.item.row.srgcd5gruppo=-127
        this.item.row.srgcd6gruppo=-127
        this.item.row.srgcd7gruppo=-127
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd2=-127
        this.item.row.srgcd3=-127
        this.item.row.srgcd4=-127
        this.item.row.srgcd5=-127
        this.item.row.srgcd6=-127
        this.item.row.srgcd7=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd2gruppo<0){
        this.item.row.srgcd3gruppo=-127
        this.item.row.srgcd4gruppo=-127
        this.item.row.srgcd5gruppo=-127
        this.item.row.srgcd6gruppo=-127
        this.item.row.srgcd7gruppo=-127
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd3=-127
        this.item.row.srgcd4=-127
        this.item.row.srgcd5=-127
        this.item.row.srgcd6=-127
        this.item.row.srgcd7=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd3gruppo<0){
        this.item.row.srgcd4gruppo=-127
        this.item.row.srgcd5gruppo=-127
        this.item.row.srgcd6gruppo=-127
        this.item.row.srgcd7gruppo=-127
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd4=-127
        this.item.row.srgcd5=-127
        this.item.row.srgcd6=-127
        this.item.row.srgcd7=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd4gruppo<0){
        this.item.row.srgcd5gruppo=-127
        this.item.row.srgcd6gruppo=-127
        this.item.row.srgcd7gruppo=-127
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd5=-127
        this.item.row.srgcd6=-127
        this.item.row.srgcd7=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd5gruppo<0){
        this.item.row.srgcd6gruppo=-127
        this.item.row.srgcd7gruppo=-127
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd6=-127
        this.item.row.srgcd7=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd6gruppo<0){
        this.item.row.srgcd7gruppo=-127
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd7=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd7gruppo<0){
        this.item.row.srgcd8gruppo=-127
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd8=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd8gruppo<0){
        this.item.row.srgcd9gruppo=-127
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd9=-127
        this.item.row.srgcd10=-127
      }
      if(this.item.row.srgcd9gruppo<0){
        this.item.row.srgcd10gruppo=-127
        this.item.row.srgcd10=-127
      }
    },
    bdcd: function(){
      if(this.item.row.bdcd1gruppo<0){
        this.item.row.bdcd2gruppo=-127
        this.item.row.bdcd3gruppo=-127
        this.item.row.bdcd4gruppo=-127
        this.item.row.bdcd5gruppo=-127
        this.item.row.bdcd2=-127
        this.item.row.bdcd3=-127
        this.item.row.bdcd4=-127
        this.item.row.bdcd5=-127
      }
      if(this.item.row.bdcd2gruppo<0){
        this.item.row.bdcd3gruppo=-127
        this.item.row.bdcd4gruppo=-127
        this.item.row.bdcd5gruppo=-127
        this.item.row.bdcd3=-127
        this.item.row.bdcd4=-127
        this.item.row.bdcd5=-127
      }
      if(this.item.row.bdcd3gruppo<0){
        this.item.row.bdcd4gruppo=-127
        this.item.row.bdcd5gruppo=-127
        this.item.row.bdcd4=-127
        this.item.row.bdcd5=-127
      }
      if(this.item.row.bdcd4gruppo<0){
        this.item.row.bdcd5gruppo=-127
        this.item.row.bdcd5=-127
      }
    },
    ebsepscd: function(){
      if(this.item.row.ebsepscd1<0){
        this.item.row.ebsepscd2=-127
      }
      if(this.item.row.ebsepscd2<0){
        this.item.row.ebsepscd3=-127
      }
    },
    lbpathcd: function(){
      if(this.item.row.lbpathcd1<0 ){
        this.item.row.lbpathcd2=-127
      }
      if(this.item.row.lbpathcd2<0){
        this.item.row.lbpathcd3=-127
      }
    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

          this.item.row.modificatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
          this.item.row.modificatoda=this.$teras.utente.id//this.$centro.referente.row.id

          let error = -1

          if((this.item.row.npgg>-1 && this.item.row.fef == 1 && this.item.row.fefgg<=this.item.row.npgg) || (this.item.row.npgg<0 && this.item.row.fef == 1))
            error = 101

          if(this.item.row.neconlm!=-9 && this.item.row.neconla!=-9 && this.item.row.neconlm_la!=-9 && this.item.row.negg!=-9)
            if(this.item.row.negg>0 && this.item.row.negg != this.item.row.neconlm + this.item.row.neconla + this.item.row.neconlm_la)
              error = 102



          switch (error){
            case -1:
            if(this.item.row.chiusoil=='0000-00-00 00:00:00'){
              await this.item.save()
              await this.$axios.query('doQuery',`CALL paziente_check_risposte(←id,@nome, @numero);`,{id: this.item.row.id})
              await this.$centro.getPaziente()
            }
            this.$router.push('/scheda-dimissione/'+this.item.row.id)
            break;

            case 101:
            this.$notify.error({title: 'Errore '+error,message: 'La Full Enteral Feeding non può essere minore dei giorni di NP!'})
            break;

            case 102:
            this.$notify.error({title: 'Errore '+error,message: 'Verifica i giorni di nutrizione enterale, per dubbi utlizza help!'})
            break;

            default:
            this.$notify.error({title: 'Errore non specificato',message: 'Siamo spiacenti si è verificato un errore, la preghiamo di verificare i dati inseriti!'})
          }
          
          this.loading.close()
          


          
        } else {
          this.$notify.error({title: 'Errore',message: "Non tutti i campi sono stati compilati correttamente!"})
          return false
        }
      })
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/scheda-salaparto/'+this.item.row.id)
    }

  },
  computed: {
    isCpapes: function (){
      let esito=true
      if( 
        (this.item.row.drcpap==0 && this.item.row.drnimv==0 && this.item.row.cpap==0 && this.item.row.nimv==0)
        ||
        (this.item.row.drcpap==-9 && (this.item.row.drnimv==0 || this.item.row.drnimv==-9) && (this.item.row.cpap==0 || this.item.row.cpap==-9) && (this.item.row.nimv==0 || this.item.row.nimv==-9))
        ||
        ((this.item.row.drcpap==0 || this.item.row.drcpap==-9) && this.item.row.drnimv==-9 && (this.item.row.cpap==0 || this.item.row.cpap==-9) && (this.item.row.nimv==0 || this.item.row.nimv==-9))
        ||
        (this.item.row.drcpap==0 && this.item.row.drnimv==0 && this.item.row.cpap==-9 && (this.item.row.nimv==0 || this.item.row.nimv==-9))
        ||
        (this.item.row.drcpap==0 && this.item.row.drnimv==0 && this.item.row.cpap==0 && this.item.row.nimv==-9)
        ||
        (this.item.row.drcpap==0 && this.item.row.drnimv==0 && this.item.row.dret==1)
        ||
        (this.item.row.drcpap==0 && this.item.row.drnimv==0 && this.item.row.dret==0 && this.item.row.vent==0 && this.item.row.hfv==0 && this.item.row.cpap==1)
        ||
        (this.item.row.drcpap==0 && this.item.row.drnimv==0 && this.item.row.dret==0 && this.item.row.vent==0 && this.item.row.hfv==0 && this.item.row.nimv==1)
        ||
        (this.item.row.drcpap==1 && this.item.row.dret==0 && this.item.row.vent==0 && this.item.row.hfv==0)
        ||
        (this.item.row.drnimv==1 && this.item.row.dret==0 && this.item.row.vent==0 && this.item.row.hfv==0)
        ||
        (this.item.row.drcpap==1 && this.item.row.dret==0 && this.item.row.vent==1)
        ||
        (this.item.row.drcpap==1 && this.item.row.dret==0 && this.item.row.hfv==1)
        ||
        (this.item.row.drnimv==1 && this.item.row.dret==0 && this.item.row.vent==1)
        ||
        (this.item.row.drnimv==1 && this.item.row.dret==0 && this.item.row.hfv==1)
        ||
        (this.item.row.dret==-9)
        ||
        (this.item.row.patoresp==0 && this.item.row.drcpap==0 && this.item.row.drnimv==0)
        ||
        (this.item.row.patoresp==0 && this.item.row.drcpap==-9 && (this.item.row.drnimv==0 || this.item.row.drnimv==-9))
        ||
        (this.item.row.patoresp==0 && (this.item.row.drcpap==0 || this.item.row.drcpap==-9) && this.item.row.drnimv==-9)
        ||
        (this.item.row.patoresp==0 && this.item.row.drcpap==1 && this.item.row.drnimv==0  && this.item.row.drnimv==0)
        ||
        (this.item.row.patoresp==0 && this.item.row.drcpap==0 && this.item.row.drnimv==1  && this.item.row.drnimv==0)
        ||
        (this.item.row.patoresp==0 && this.item.row.drcpap==1 && this.item.row.drnimv==1  && this.item.row.drnimv==0)
        ||
        (this.item.row.patoresp==0 && this.item.row.drcpap==0 && this.item.row.drnimv==0  && this.item.row.drnimv==1)
      ){
        esito = false
      }
      return esito
    },
    isAlive: function(){
      return (this.item.row.deldie!=1) ? true : false;
    },
    isAlivePlus: function(){
      return (this.item.row.deldie!=1 && this.item.row.die12!=1) ? true : false;
    },
    isAliveLocate: function(){
      return (this.item.row.locate==0 && this.item.row.deldie!=1 && this.item.row.die12!=1) || (this.item.row.locate==1) ? true : false;
    },
    after3: function (){
      let esito = true
      if(this.item.row.dataesito!='')
        esito = this.$moment(this.item.row.dataesito).isAfter(this.$centro.giorno3(this.item.row.datanascita))
      return esito 
    },
    after28: function (){
      let esito = true
      if(this.item.row.f2disp!=4 && this.item.row.dataesito!='')
        esito = this.$moment(this.item.row.dataesito).isSameOrAfter(this.$centro.giorno28(this.item.row.datanascita))
      if(this.item.row.f2disp==4 && this.item.row.dfd!='')
        esito = this.$moment(this.item.row.dfd).isSameOrAfter(this.$centro.giorno28(this.item.row.datanascita))
      return esito 
    },
    after36: function (){
      let esito = true
      console.log("AFTER 36 DEBUG")
      console.log("AFTER 36 DEBUG "+this.item.row.dataesito)
      esito = this.$moment().isSameOrAfter(this.$centro.settimana36(this.item.row.datanascita,this.item.row.gaweeks,this.item.row.gadays)) 

      if(this.item.row.f2disp!=4 && this.item.row.dataesito!=''){
        esito = this.$moment(this.item.row.dataesito).isSameOrAfter(this.$centro.settimana36(this.item.row.datanascita,this.item.row.gaweeks,this.item.row.gadays))
      }
      if(this.item.row.f2disp==4 && this.item.row.dfd!=''){
        esito = this.$moment(this.item.row.dfd).isSameOrAfter(this.$centro.settimana36(this.item.row.datanascita,this.item.row.gaweeks,this.item.row.gadays))
      }
      if(this.item.row.gaweeks>36)
        esito = true
      return esito 
    },

    rulesForm:function() {
      var rulesNow = {
        /*
        importo: [
          //{ required: true, message: 'L\'importo è obbligatorio' },
          { min: 1, max: 5000, message: 'Bisogna indicare un importo', trigger: 'blur' }
        ],
        */
        step: [
          { required: true, message: 'Lo status è obbligatorio'}
        ],
        eseguitoil: [
          { required: true, message: 'Il giorno di esecuzione è obbligatorio'}
        ],
        incassatoil: [
          { required: true, message: 'Il giorno di incasso è obbligatorio'}
        ]

      }
      return rulesNow
    }
  }
}
</script>
<style >
.formRow > .col {
    background-color: #F9F9FA;
}.formRow > .col:nth-child(odd) {
    background-color: #EFF0F2;
}.formRow > .col .el-form-item{
  margin-top:10px;
  margin-bottom:18px;
}.formRow > .col .el-form-item__content{
  margin-right:12px;

  
}
</style>